import {
  createInvertedMessages,
  type InvertedLocalize as InvertedLocalizeType,
  useInvertedLocalize as useIL,
} from './generic';
import {
  description,
  emptyState,
  errorState,
  infoState,
  label,
  misc,
  placeholder,
  progressState,
  prompt,
  successState,
  title,
} from './messages';

/** Exported for testing. It's not necessary to access this directly. */
export const invertedMessages = createInvertedMessages([
  description,
  emptyState,
  errorState,
  infoState,
  label,
  misc,
  placeholder,
  progressState,
  prompt,
  successState,
  title,
]);

/** Inverted messages type. Contains all the messages that can be translated. */
export type LocalizationMessages = keyof typeof invertedMessages;
/** Translation function type. Will throw an error if a string isn't added to a category. */
export type InvertedLocalize = InvertedLocalizeType<LocalizationMessages>;
/** Hook to allow type safe translations. */
export const useInvertedLocalize = (): InvertedLocalize =>
  useIL(invertedMessages);
